import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { ACTION_DETAILS, ACTION_LIST } from "models/role/action";
import { SUBJECT_WORKFLOWS } from "models/role/subject";
import { lazyRetryWithPreload } from "utils/lazyRetryWithPreload";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const List = lazyRetryWithPreload(() => import("../pages/List"), "List");

const Details = lazyRetryWithPreload(
  () => import("../pages/Details"),
  "Details"
);

const Edit = lazyRetryWithPreload(() => import("../pages/Edit"), "Edit");

export const workflowsRoutes: Route = {
  title: [COMMON_TRANSLATION_KEYS.workflows, COMMON_TRANSLATION_KEYS.list],
  path: PAGE_URLS.list,
  component: List,
  can: { do: ACTION_LIST, on: SUBJECT_WORKFLOWS },
  children: [
    {
      title: [
        COMMON_TRANSLATION_KEYS.workflows,
        COMMON_TRANSLATION_KEYS.details,
      ],
      path: PAGE_URLS.details,
      component: Details,
      can: { do: ACTION_DETAILS, on: SUBJECT_WORKFLOWS },
    },
    {
      title: [COMMON_TRANSLATION_KEYS.workflows, COMMON_TRANSLATION_KEYS.edit],
      path: PAGE_URLS.edit,
      component: Edit,
      can: { do: ACTION_DETAILS, on: SUBJECT_WORKFLOWS },
    },
  ],
};
